import { getPressReleases } from "@clients/afaseApiClient";
import { mapPressReleasesToListEntries } from "@utils/mappers/pressReleaseListEntryMapper";
import { SiteCacheItem, siteCacheFetch } from "@utils/siteStructureCache";

import { PressReleaseListEntry } from "types/PressReleaseListEntry";

export const getPressReleaseListEntries = async (): Promise<Array<PressReleaseListEntry>> => {
  return siteCacheFetch(SiteCacheItem.PRESS_RELEASE_LIST, async () => {
    const pressReleases = await getPressReleases();
    return mapPressReleasesToListEntries(pressReleases);
  });
};
